export const conversationMetrics = [
    {
        "timestamp": "2024-03",
        "sentiment_score": 0.6812,
        "dominant_emotion": "sadness",
        "emotion_score": 0.9415,
        "information_entropy": 0.2006,
        "lexical_diversity": 0.0,
        "readability_score": 100.24,
        "topic": 2,
        "semantic_similarity": 0.1544,
        "user": 14
    },
    {
        "timestamp": "2024-03",
        "sentiment_score": 0.7234,
        "dominant_emotion": "joy",
        "emotion_score": 0.8876,
        "information_entropy": 0.2453,
        "lexical_diversity": 0.12,
        "readability_score": 95.67,
        "topic": 1,
        "semantic_similarity": 0.2231,
        "user": 14
    },
    {
        "timestamp": "2024-03",
        "sentiment_score": 0.4567,
        "dominant_emotion": "fear",
        "emotion_score": 0.7654,
        "information_entropy": 0.1876,
        "lexical_diversity": 0.08,
        "readability_score": 88.92,
        "topic": 3,
        "semantic_similarity": 0.3112,
        "user": 14
    },
    {
        "timestamp": "2024-05",
        "sentiment_score": 0.8234,
        "dominant_emotion": "joy",
        "emotion_score": 0.9123,
        "information_entropy": 0.2789,
        "lexical_diversity": 0.15,
        "readability_score": 105.45,
        "topic": 2,
        "semantic_similarity": 0.1876,
        "user": 14
    },
    {
        "timestamp": "2024-05",
        "sentiment_score": 0.3456,
        "dominant_emotion": "anger",
        "emotion_score": 0.8765,
        "information_entropy": 0.1543,
        "lexical_diversity": 0.05,
        "readability_score": 92.31,
        "topic": 4,
        "semantic_similarity": 0.2543,
        "user": 14
    },
    {
        "timestamp": "2024-04",
        "sentiment_score": 0.5678,
        "dominant_emotion": "surprise",
        "emotion_score": 0.7123,
        "information_entropy": 0.2234,
        "lexical_diversity": 0.11,
        "readability_score": 97.86,
        "topic": 1,
        "semantic_similarity": 0.1987,
        "user": 14
    },
    {
        "timestamp": "2024-06",
        "sentiment_score": 0.7890,
        "dominant_emotion": "joy",
        "emotion_score": 0.8543,
        "information_entropy": 0.2567,
        "lexical_diversity": 0.14,
        "readability_score": 103.12,
        "topic": 2,
        "semantic_similarity": 0.2765,
        "user": 14
    },
    {
        "timestamp": "2024-06",
        "sentiment_score": 0.4321,
        "dominant_emotion": "disgust",
        "emotion_score": 0.6789,
        "information_entropy": 0.1765,
        "lexical_diversity": 0.07,
        "readability_score": 91.45,
        "topic": 3,
        "semantic_similarity": 0.3234,
        "user": 14
    },
    {
        "timestamp": "2024-07",
        "sentiment_score": 0.6543,
        "dominant_emotion": "sadness",
        "emotion_score": 0.8234,
        "information_entropy": 0.2123,
        "lexical_diversity": 0.09,
        "readability_score": 98.76,
        "topic": 2,
        "semantic_similarity": 0.1654,
        "user": 14
    },
    {
        "timestamp": "2024-10",
        "sentiment_score": 0.5432,
        "dominant_emotion": "surprise",
        "emotion_score": 0.7456,
        "information_entropy": 0.1987,
        "lexical_diversity": 0.10,
        "readability_score": 94.23,
        "topic": 1,
        "semantic_similarity": 0.2876,
        "user": 14
    }
]

export const conversationFlow = [
    {
        "id": 9,
        "avg_message_length": 16.4,
        "turn_taking_rate": 0.0012,
        "question_frequency": 0.0,
        "command_frequency": 0.0,
        // "timestamp": "2024-09-25T11:37:43.354226Z",
        "timestamp": "2024-03",
        "user_id": 14,
        "conversation_id": "7bd97676-418f-4d5d-9dbf-076119876474"
    },
    {
        "id": 10,
        "avg_message_length": 22.7,
        "turn_taking_rate": 0.0018,
        "question_frequency": 0.15,
        "command_frequency": 0.05,
        "timestamp": "2024-03",
        "user_id": 14,
        "conversation_id": "9cd45678-512e-4a6b-8ef9-123456789012"
    },
    {
        "id": 11,
        "avg_message_length": 18.9,
        "turn_taking_rate": 0.0015,
        "question_frequency": 0.08,
        "command_frequency": 0.02,
        "timestamp": "2024-05",
        "user_id": 14,
        "conversation_id": "3ef56789-623f-4b7c-9fg0-234567890123"
    },
    {
        "id": 12,
        "avg_message_length": 25.3,
        "turn_taking_rate": 0.0021,
        "question_frequency": 0.22,
        "command_frequency": 0.07,
        "timestamp": "2024-02",
        "user_id": 14,
        "conversation_id": "4gh67890-734g-4c8d-0hi1-345678901234"
    },
    {
        "id": 13,
        "avg_message_length": 19.8,
        "turn_taking_rate": 0.0014,
        "question_frequency": 0.12,
        "command_frequency": 0.03,
        "timestamp": "2024-06",
        "user_id": 14,
        "conversation_id": "5hi78901-845h-4d9e-1ij2-456789012345"
    },
    {
        "id": 14,
        "avg_message_length": 21.5,
        "turn_taking_rate": 0.0017,
        "question_frequency": 0.18,
        "command_frequency": 0.06,
        "timestamp": "2024-06",
        "user_id": 14,
        "conversation_id": "6ij89012-956i-4e0f-2jk3-567890123456"
    },
    {
        "id": 15,
        "avg_message_length": 17.2,
        "turn_taking_rate": 0.0013,
        "question_frequency": 0.05,
        "command_frequency": 0.01,
        "timestamp": "2024-02",
        "user_id": 14,
        "conversation_id": "7jk90123-067j-4f1g-3kl4-678901234567"
    },
    {
        "id": 16,
        "avg_message_length": 24.1,
        "turn_taking_rate": 0.0020,
        "question_frequency": 0.25,
        "command_frequency": 0.08,
        "timestamp": "2024-03",
        "user_id": 14,
        "conversation_id": "8kl01234-178k-4g2h-4lm5-789012345678"
    },
    {
        "id": 17,
        "avg_message_length": 20.6,
        "turn_taking_rate": 0.0016,
        "question_frequency": 0.15,
        "command_frequency": 0.04,
        "timestamp": "2024-02",
        "user_id": 14,
        "conversation_id": "9lm12345-289l-4h3i-5mn6-890123456789"
    },
    {
        "id": 18,
        "avg_message_length": 23.8,
        "turn_taking_rate": 0.0019,
        "question_frequency": 0.20,
        "command_frequency": 0.07,
        "timestamp": "2024-07",
        "user_id": 14,
        "conversation_id": "0mn23456-390m-4i4j-6no7-901234567890"
    }
]

export const lsmData = [
    {
    "user_id": 1,
    "score": 15,
    "timestamp": "January",
    "conversation_id": "123sd-gthfh-g5b-ew321"
  },
  {
    "user_id": 1,
    "score": 12,
    "timestamp": "February",
    "conversation_id": "123sd-gthfh-g5b-ew321"
  },
  {
    "user_id": 1,
    "score": 34,
    "timestamp": "March",
    "conversation_id": "123sd-gthfh-g5b-ew321"
  },
  {
    "user_id": 1,
    "score": 19,
    "timestamp": "April",
    "conversation_id": "123sd-gthfh-g5b-ew321"
  },
  {
    "user_id": 1,
    "score": 52,
    "timestamp": "May",
    "conversation_id": "123sd-gthfh-g5b-ew321"
  },
    ]


export const similarityScores = [
    {
        "user": "User 14",
        "similarity_score": 0.74
    },
    {
        "user": "User 23",
        "similarity_score": 0.68
    },
    {
        "user": "User 37",
        "similarity_score": 0.82
    },
    {
        "user": "User 45",
        "similarity_score": 0.59
    },
    {
        "user": "User 51",
        "similarity_score": 0.77
    },
    {
        "user": "User 62",
        "similarity_score": 0.71
    },
    {
        "user": "User 78",
        "similarity_score": 0.65
    },
    // {
    //     "user": "User 89",
    //     "similarity_score": 0.88
    // },
    // {
    //     "user": "User 9",
    //     "similarity_score": 0.63
    // },
    // {
    //     "user": "User 96",
    //     "similarity_score": 0.79
    // }
]


export const sampleData = [
      {
        id: 1,
        name: "User A",
        psychometrics: {
          conversationMetrics,
          conversationFlow,
          lsmScores: [
            {
                "user_id": 14,
                "category": 'Personal Pronouns',
                "score": 15,
                "timestamp": "2024-03",
                "conversation_id": "123sd-gthfh-g5b-ew321"
              },
              {
                "user_id": 14,
                "category": 'Impersonal Pronouns',
                "score": 12,
                "timestamp": "2024-03",
                "conversation_id": "123sd-gthfh-g5b-ew321"
              },
              {
                "user_id": 14,
                "category": 'Articles',
                "score": 34,
                "timestamp": "2024-02",
                "conversation_id": "123sd-gthfh-g5b-ew321"
              },
              {
                "user_id": 14,
                "score": 19,
                "category": 'Prepositions',
                "timestamp": "2024-03",
                "conversation_id": "123sd-gthfh-g5b-ew321"
              },
              {
                "user_id": 14,
                "category": 'Auxiliary Verbs',
                "score": 52,
                "timestamp": "2024-04",
                "conversation_id": "123sd-gthfh-g5b-ew321"
              },
          ],
        }
      },

    ]
